<div class="d-flex">
  <div class="col-3"></div>
  <div class="col-6">
    <div class="d-flex justify-content-center p-3" >
      <ngb-pagination
        [collectionSize]="count"
        [(page)]="pageNumber"
        [page]="pageReady ? pageNumber : 1"
        [pageSize]="pageSize"
        [rotate]="true"
        [boundaryLinks]="true"
        [maxSize]="10"
        (pageChange)="onPageChange($event)"
        (click)="manualPageChange = true"
      >
      </ngb-pagination>
    </div>
  </div>
  <div class="col-3" *ngIf="pageNumber>0">
    <div class="d-flex justify-content-end p-3">
      <ng-container *ngIf="availablePageSizes?.length else default">
        <select
          class="form-select"
          style="width: auto"
          name="pageSize"
          (ngModelChange)="detectChangePageSize($event)"
          [(ngModel)]="changePageSize"
        >        
          <option *ngFor="let pageSize of availablePageSizes" [ngValue]="pageSize">
            {{ pageSize + " " }} {{ "pagination.itemsPerPage" | translate }}
          </option>
          <option [ngValue]="count">
            {{ "pagination.allItems" | translate }}
          </option>
        </select>
      </ng-container>
      <ng-template #default>
        <select
          class="form-select"
          style="width: auto"
          name="pageSize"
          (ngModelChange)="detectChangePageSize($event)"
          [(ngModel)]="changePageSize"
        >
          
        
          <option [ngValue]="10">
            10 {{ "pagination.itemsPerPage" | translate }}
          </option>
          <option [ngValue]="15">
            15 {{ "pagination.itemsPerPage" | translate }}
          </option>
          <option [ngValue]="20">
            20 {{ "pagination.itemsPerPage" | translate }}
          </option>
          <option [ngValue]="count">
            {{ "pagination.allItems" | translate }}
          </option>
        </select>
      </ng-template>
    </div>
  </div>
</div>
